'use strict';

define('app/templates/_helpers/formatMoney',['Handlebars', 'accounting'], function (Handlebars, accounting) {
  return Handlebars.registerHelper('formatMoney', function formatMoney(num) {
    return accounting.formatMoney(num);
  });
});

